import React from 'react';
import Loadable from 'react-loadable';
import Loader from 'desktop/components/Common/BlankLoader.js';

const MyAccountLoadable = Loadable({
    loader: () => import('desktop/containers/MyAccount/MyAccount.js' /* webpackChunkName: 'pageAccount' */).then(module => module.default),
    loading: () => <Loader />
});

export default MyAccountLoadable;
